module.exports = {
          srcSet: __webpack_public_path__ + "8680f4d9d7ffd20e9812f922f7510dc1-7820.png"+" 7820w",
          images:[ {path: __webpack_public_path__ + "8680f4d9d7ffd20e9812f922f7510dc1-7820.png",width: 7820,height: 6159}],
          src: __webpack_public_path__ + "8680f4d9d7ffd20e9812f922f7510dc1-7820.png",
          toString:function(){return __webpack_public_path__ + "8680f4d9d7ffd20e9812f922f7510dc1-7820.png"},
          
          width: 7820,
          height: 6159
        }